{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"scale": [0.2219294011592865, 0.41191592812538147, 0.21694616973400116],
			"translation": [-0.35598114132881165, 0.5128358006477356, 0.2841683328151703]
		},
		{
			"mesh": 1,
			"name": "Sphere",
			"scale": [0.579379677772522, 0.9933834671974182, 0.5663701891899109],
			"translation": [-0.35598114132881165, 0.8474234342575073, 0.2841683328151703]
		},
		{
			"mesh": 2,
			"name": "Cone",
			"scale": [0.5756955742835999, 0.9870668649673462, 0.5627686977386475],
			"translation": [-0.35598114132881165, 1.8381798267364502, 0.2841683328151703]
		},
		{
			"mesh": 3,
			"name": "Cube.001",
			"scale": [1.043144941329956, 1.043144941329956, 1.043144941329956],
			"translation": [-0.013388097286224365, 0.09432722628116608, 0.005069144070148468]
		},
		{
			"mesh": 4,
			"name": "Sphere.001",
			"rotation": [0, 0.4348374009132385, 0, 0.9005089998245239],
			"scale": [0.39453792572021484, 0.4555589556694031, 0.3965023458003998],
			"translation": [0.3972209393978119, 0.568670392036438, -0.4756075441837311]
		},
		{
			"mesh": 5,
			"name": "Cube.002",
			"rotation": [0, 0.4348374009132385, 0, 0.9005089998245239],
			"scale": [0.15112638473510742, 0.1889018565416336, 0.15187886357307434],
			"translation": [0.3972209393978119, 0.4152306914329529, -0.4756075441837311]
		},
		{
			"mesh": 6,
			"name": "Cone.001",
			"rotation": [0, 0.4348374307155609, 0, 0.9005089998245239],
			"scale": [0.39202913641929626, 0.4526621401309967, 0.393981009721756],
			"translation": [0.3972209393978119, 1.023024559020996, -0.4756075441837311]
		},
		{
			"mesh": 7,
			"name": "Sphere.002",
			"rotation": [0, -0.8467515110969543, 0, 0.531988799571991],
			"scale": [0.18963417410850525, 0.2283889800310135, 0.18367400765419006],
			"translation": [0.4443117380142212, 0.47942936420440674, 0.4978940784931183]
		},
		{
			"mesh": 8,
			"name": "Cube.003",
			"rotation": [0, -0.8467515110969543, 0, 0.531988799571991],
			"scale": [0.07263873517513275, 0.09470367431640625, 0.07035569846630096],
			"translation": [0.4443117380142212, 0.40250420570373535, 0.4978940784931183]
		},
		{
			"mesh": 9,
			"name": "Cone.002",
			"rotation": [0, -0.8467515110969543, 0, 0.531988799571991],
			"scale": [0.1884283721446991, 0.22693675756454468, 0.1825060248374939],
			"translation": [0.4443117380142212, 0.7072142958641052, 0.4978940784931183]
		},
		{
			"mesh": 10,
			"name": "Sphere.003",
			"rotation": [0, -0.578613817691803, 0, 0.815601646900177],
			"scale": [0.21261969208717346, 0.25607195496559143, 0.20593710243701935],
			"translation": [-0.4459078013896942, 0.4722128212451935, -0.5085146427154541]
		},
		{
			"mesh": 11,
			"name": "Cube.004",
			"rotation": [0, -0.578613817691803, 0, 0.815601646900177],
			"scale": [0.08144325762987137, 0.10618269443511963, 0.07888349890708923],
			"translation": [-0.4459078013896942, 0.38596364855766296, -0.5085146427154541]
		},
		{
			"mesh": 12,
			"name": "Cone.003",
			"rotation": [0, -0.578613817691803, 0, 0.815601646900177],
			"scale": [0.21126770973205566, 0.2544437348842621, 0.20462755858898163],
			"translation": [-0.4459078013896942, 0.7138693928718567, -0.5085146427154541]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.007",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.5396742224693298, 0.3806949257850647, 0.2986829876899719, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.643790602684021, 0.11780326068401337, 0.04442593827843666, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7086614370346069
			}
		},
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0346306748688221, 0.15950310230255127, 0.800536572933197, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.007156526669859886, 0.8002041578292847, 0.008485140278935432, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.004",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.4119221568107605, 0.010700240731239319, 0.8005756139755249, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.008",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8001565933227539, 0.6568794250488281, 0.0061951447278261185, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.015",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.12350903451442719, 0.11144945025444031, 0.09248222410678864, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.6351044178009033, 0.021436916664242744, 0.025999007746577263, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7086614370346069
			}
		},
		{
			"doubleSided": true,
			"name": "Material.009",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0346306748688221, 0.15950310230255127, 0.800536572933197, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.010",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.007156526669859886, 0.8002041578292847, 0.008485140278935432, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.011",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.4119221568107605, 0.010700240731239319, 0.8005756139755249, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.012",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8001565933227539, 0.6568794250488281, 0.0061951447278261185, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.013",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.5396742224693298, 0.3806949257850647, 0.2986829876899719, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.016",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.08159928768873215, 0.637035071849823, 0.051704198122024536, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7086614370346069
			}
		},
		{
			"doubleSided": true,
			"name": "Material.017",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0346306748688221, 0.15950310230255127, 0.800536572933197, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.018",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.007156526669859886, 0.8002041578292847, 0.008485140278935432, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.019",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.4119221568107605, 0.010700240731239319, 0.8005756139755249, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.020",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8001565933227539, 0.6568794250488281, 0.0061951447278261185, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.021",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.5396742224693298, 0.3806949257850647, 0.2986829876899719, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.022",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.03314121440052986, 0.11106905341148376, 0.6355799436569214, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7086614370346069
			}
		},
		{
			"doubleSided": true,
			"name": "Material.023",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0346306748688221, 0.15950310230255127, 0.800536572933197, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.024",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.007156526669859886, 0.8002041578292847, 0.008485140278935432, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.025",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.4119221568107605, 0.010700240731239319, 0.8005756139755249, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.026",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8001565933227539, 0.6568794250488281, 0.0061951447278261185, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.20000000298023224
			}
		},
		{
			"doubleSided": true,
			"name": "Material.027",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.5396742224693298, 0.3806949257850647, 0.2986829876899719, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Sphere",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				},
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 15,
					"material": 3
				},
				{
					"attributes": {
						"POSITION": 16,
						"NORMAL": 17,
						"TEXCOORD_0": 18
					},
					"indices": 19,
					"material": 4
				},
				{
					"attributes": {
						"POSITION": 20,
						"NORMAL": 21,
						"TEXCOORD_0": 22
					},
					"indices": 23,
					"material": 5
				}
			]
		},
		{
			"name": "Cone",
			"primitives": [
				{
					"attributes": {
						"POSITION": 24,
						"NORMAL": 25,
						"TEXCOORD_0": 26
					},
					"indices": 27,
					"material": 1
				}
			]
		},
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 28,
						"NORMAL": 29,
						"TEXCOORD_0": 30
					},
					"indices": 31,
					"material": 6
				}
			]
		},
		{
			"name": "Sphere.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 32,
						"NORMAL": 33,
						"TEXCOORD_0": 34
					},
					"indices": 7,
					"material": 7
				},
				{
					"attributes": {
						"POSITION": 35,
						"NORMAL": 36,
						"TEXCOORD_0": 37
					},
					"indices": 11,
					"material": 8
				},
				{
					"attributes": {
						"POSITION": 38,
						"NORMAL": 39,
						"TEXCOORD_0": 40
					},
					"indices": 15,
					"material": 9
				},
				{
					"attributes": {
						"POSITION": 41,
						"NORMAL": 42,
						"TEXCOORD_0": 43
					},
					"indices": 19,
					"material": 10
				},
				{
					"attributes": {
						"POSITION": 44,
						"NORMAL": 45,
						"TEXCOORD_0": 46
					},
					"indices": 23,
					"material": 11
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 47,
						"NORMAL": 48,
						"TEXCOORD_0": 49
					},
					"indices": 3,
					"material": 12
				}
			]
		},
		{
			"name": "Cone.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 50,
						"NORMAL": 51,
						"TEXCOORD_0": 52
					},
					"indices": 27,
					"material": 7
				}
			]
		},
		{
			"name": "Sphere.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 53,
						"NORMAL": 54,
						"TEXCOORD_0": 55
					},
					"indices": 7,
					"material": 13
				},
				{
					"attributes": {
						"POSITION": 56,
						"NORMAL": 57,
						"TEXCOORD_0": 58
					},
					"indices": 11,
					"material": 14
				},
				{
					"attributes": {
						"POSITION": 59,
						"NORMAL": 60,
						"TEXCOORD_0": 61
					},
					"indices": 15,
					"material": 15
				},
				{
					"attributes": {
						"POSITION": 62,
						"NORMAL": 63,
						"TEXCOORD_0": 64
					},
					"indices": 19,
					"material": 16
				},
				{
					"attributes": {
						"POSITION": 65,
						"NORMAL": 66,
						"TEXCOORD_0": 67
					},
					"indices": 23,
					"material": 17
				}
			]
		},
		{
			"name": "Cube.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 68,
						"NORMAL": 69,
						"TEXCOORD_0": 70
					},
					"indices": 3,
					"material": 18
				}
			]
		},
		{
			"name": "Cone.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 71,
						"NORMAL": 72,
						"TEXCOORD_0": 73
					},
					"indices": 27,
					"material": 13
				}
			]
		},
		{
			"name": "Sphere.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 74,
						"NORMAL": 75,
						"TEXCOORD_0": 76
					},
					"indices": 7,
					"material": 19
				},
				{
					"attributes": {
						"POSITION": 77,
						"NORMAL": 78,
						"TEXCOORD_0": 79
					},
					"indices": 11,
					"material": 20
				},
				{
					"attributes": {
						"POSITION": 80,
						"NORMAL": 81,
						"TEXCOORD_0": 82
					},
					"indices": 15,
					"material": 21
				},
				{
					"attributes": {
						"POSITION": 83,
						"NORMAL": 84,
						"TEXCOORD_0": 85
					},
					"indices": 19,
					"material": 22
				},
				{
					"attributes": {
						"POSITION": 86,
						"NORMAL": 87,
						"TEXCOORD_0": 88
					},
					"indices": 23,
					"material": 23
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 89,
						"NORMAL": 90,
						"TEXCOORD_0": 91
					},
					"indices": 3,
					"material": 24
				}
			]
		},
		{
			"name": "Cone.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 92,
						"NORMAL": 93,
						"TEXCOORD_0": 94
					},
					"indices": 27,
					"material": 19
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 48,
			"max": [1, 1, 1],
			"min": [-1, -0.46962040662765503, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 48,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 48,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 848,
			"max": [0.9999997019767761, 1, 0.9999993443489075],
			"min": [-0.9999990463256836, 0, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 848,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 848,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 1224,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 36,
			"max": [0.9061272144317627, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.9619393944740295, 0.19509032368659973, -0.5879376530647278],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 54,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 36,
			"max": [0.9619396328926086, 0.9238795042037964, 0.9807849526405334],
			"min": [-0.8154926300048828, 0.19509032368659973, -0.513279914855957],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5123,
			"count": 54,
			"type": "SCALAR"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 36,
			"max": [0.3928474187850952, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.6935193538665771, 0.19509032368659973, -0.906127393245697],
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 19,
			"componentType": 5123,
			"count": 54,
			"type": "SCALAR"
		},
		{
			"bufferView": 20,
			"componentType": 5126,
			"count": 36,
			"max": [0.8314694166183472, 0.9807852506637573, 0.8535531163215637],
			"min": [-0.9619392156600952, 0.19509032368659973, -0.6935197710990906],
			"type": "VEC3"
		},
		{
			"bufferView": 21,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 22,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 23,
			"componentType": 5123,
			"count": 54,
			"type": "SCALAR"
		},
		{
			"bufferView": 24,
			"componentType": 5126,
			"count": 32,
			"max": [1, -1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 25,
			"componentType": 5126,
			"count": 32,
			"type": "VEC3"
		},
		{
			"bufferView": 26,
			"componentType": 5126,
			"count": 32,
			"type": "VEC2"
		},
		{
			"bufferView": 27,
			"componentType": 5123,
			"count": 90,
			"type": "SCALAR"
		},
		{
			"bufferView": 28,
			"componentType": 5126,
			"count": 167,
			"max": [1.5770962238311768, 0.2517635226249695, 1.6353305578231812],
			"min": [-1.6849838495254517, -0.1256502866744995, -1.816280484199524],
			"type": "VEC3"
		},
		{
			"bufferView": 29,
			"componentType": 5126,
			"count": 167,
			"type": "VEC3"
		},
		{
			"bufferView": 30,
			"componentType": 5126,
			"count": 167,
			"type": "VEC2"
		},
		{
			"bufferView": 31,
			"componentType": 5123,
			"count": 288,
			"type": "SCALAR"
		},
		{
			"bufferView": 32,
			"componentType": 5126,
			"count": 848,
			"max": [0.9999997019767761, 1, 0.9999993443489075],
			"min": [-0.9999990463256836, 0, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 33,
			"componentType": 5126,
			"count": 848,
			"type": "VEC3"
		},
		{
			"bufferView": 34,
			"componentType": 5126,
			"count": 848,
			"type": "VEC2"
		},
		{
			"bufferView": 35,
			"componentType": 5126,
			"count": 36,
			"max": [0.9061272144317627, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.9619393944740295, 0.19509032368659973, -0.5879376530647278],
			"type": "VEC3"
		},
		{
			"bufferView": 36,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 37,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 38,
			"componentType": 5126,
			"count": 36,
			"max": [0.9619396328926086, 0.9238795042037964, 0.9807849526405334],
			"min": [-0.8154926300048828, 0.19509032368659973, -0.513279914855957],
			"type": "VEC3"
		},
		{
			"bufferView": 39,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 40,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 41,
			"componentType": 5126,
			"count": 36,
			"max": [0.3928474187850952, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.6935193538665771, 0.19509032368659973, -0.906127393245697],
			"type": "VEC3"
		},
		{
			"bufferView": 42,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 43,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 44,
			"componentType": 5126,
			"count": 36,
			"max": [0.8314694166183472, 0.9807852506637573, 0.8535531163215637],
			"min": [-0.9619392156600952, 0.19509032368659973, -0.6935197710990906],
			"type": "VEC3"
		},
		{
			"bufferView": 45,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 46,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 47,
			"componentType": 5126,
			"count": 48,
			"max": [1, 1, 1],
			"min": [-1, -0.46962040662765503, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 48,
			"componentType": 5126,
			"count": 48,
			"type": "VEC3"
		},
		{
			"bufferView": 49,
			"componentType": 5126,
			"count": 48,
			"type": "VEC2"
		},
		{
			"bufferView": 50,
			"componentType": 5126,
			"count": 32,
			"max": [1, -1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 51,
			"componentType": 5126,
			"count": 32,
			"type": "VEC3"
		},
		{
			"bufferView": 52,
			"componentType": 5126,
			"count": 32,
			"type": "VEC2"
		},
		{
			"bufferView": 53,
			"componentType": 5126,
			"count": 848,
			"max": [0.9999997019767761, 1, 0.9999993443489075],
			"min": [-0.9999990463256836, 0, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 54,
			"componentType": 5126,
			"count": 848,
			"type": "VEC3"
		},
		{
			"bufferView": 55,
			"componentType": 5126,
			"count": 848,
			"type": "VEC2"
		},
		{
			"bufferView": 56,
			"componentType": 5126,
			"count": 36,
			"max": [0.9061272144317627, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.9619393944740295, 0.19509032368659973, -0.5879376530647278],
			"type": "VEC3"
		},
		{
			"bufferView": 57,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 58,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 59,
			"componentType": 5126,
			"count": 36,
			"max": [0.9619396328926086, 0.9238795042037964, 0.9807849526405334],
			"min": [-0.8154926300048828, 0.19509032368659973, -0.513279914855957],
			"type": "VEC3"
		},
		{
			"bufferView": 60,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 61,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 62,
			"componentType": 5126,
			"count": 36,
			"max": [0.3928474187850952, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.6935193538665771, 0.19509032368659973, -0.906127393245697],
			"type": "VEC3"
		},
		{
			"bufferView": 63,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 64,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 65,
			"componentType": 5126,
			"count": 36,
			"max": [0.8314694166183472, 0.9807852506637573, 0.8535531163215637],
			"min": [-0.9619392156600952, 0.19509032368659973, -0.6935197710990906],
			"type": "VEC3"
		},
		{
			"bufferView": 66,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 67,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 68,
			"componentType": 5126,
			"count": 48,
			"max": [1, 1, 1],
			"min": [-1, -0.46962040662765503, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 69,
			"componentType": 5126,
			"count": 48,
			"type": "VEC3"
		},
		{
			"bufferView": 70,
			"componentType": 5126,
			"count": 48,
			"type": "VEC2"
		},
		{
			"bufferView": 71,
			"componentType": 5126,
			"count": 32,
			"max": [1, -1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 72,
			"componentType": 5126,
			"count": 32,
			"type": "VEC3"
		},
		{
			"bufferView": 73,
			"componentType": 5126,
			"count": 32,
			"type": "VEC2"
		},
		{
			"bufferView": 74,
			"componentType": 5126,
			"count": 848,
			"max": [0.9999997019767761, 1, 0.9999993443489075],
			"min": [-0.9999990463256836, 0, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 75,
			"componentType": 5126,
			"count": 848,
			"type": "VEC3"
		},
		{
			"bufferView": 76,
			"componentType": 5126,
			"count": 848,
			"type": "VEC2"
		},
		{
			"bufferView": 77,
			"componentType": 5126,
			"count": 36,
			"max": [0.9061272144317627, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.9619393944740295, 0.19509032368659973, -0.5879376530647278],
			"type": "VEC3"
		},
		{
			"bufferView": 78,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 79,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 80,
			"componentType": 5126,
			"count": 36,
			"max": [0.9619396328926086, 0.9238795042037964, 0.9807849526405334],
			"min": [-0.8154926300048828, 0.19509032368659973, -0.513279914855957],
			"type": "VEC3"
		},
		{
			"bufferView": 81,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 82,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 83,
			"componentType": 5126,
			"count": 36,
			"max": [0.3928474187850952, 0.9807852506637573, 0.6935198307037354],
			"min": [-0.6935193538665771, 0.19509032368659973, -0.906127393245697],
			"type": "VEC3"
		},
		{
			"bufferView": 84,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 85,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 86,
			"componentType": 5126,
			"count": 36,
			"max": [0.8314694166183472, 0.9807852506637573, 0.8535531163215637],
			"min": [-0.9619392156600952, 0.19509032368659973, -0.6935197710990906],
			"type": "VEC3"
		},
		{
			"bufferView": 87,
			"componentType": 5126,
			"count": 36,
			"type": "VEC3"
		},
		{
			"bufferView": 88,
			"componentType": 5126,
			"count": 36,
			"type": "VEC2"
		},
		{
			"bufferView": 89,
			"componentType": 5126,
			"count": 48,
			"max": [1, 1, 1],
			"min": [-1, -0.46962040662765503, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 90,
			"componentType": 5126,
			"count": 48,
			"type": "VEC3"
		},
		{
			"bufferView": 91,
			"componentType": 5126,
			"count": 48,
			"type": "VEC2"
		},
		{
			"bufferView": 92,
			"componentType": 5126,
			"count": 32,
			"max": [1, -1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 93,
			"componentType": 5126,
			"count": 32,
			"type": "VEC3"
		},
		{
			"bufferView": 94,
			"componentType": 5126,
			"count": 32,
			"type": "VEC2"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 576,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 1152,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 1536,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 1704,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 11880,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6784,
			"byteOffset": 22056,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2448,
			"byteOffset": 28840,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 31288,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 31720,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 32152,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 108,
			"byteOffset": 32440,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 32548,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 32980,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 33412,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 108,
			"byteOffset": 33700,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 33808,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 34240,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 34672,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 108,
			"byteOffset": 34960,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 35068,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 35500,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 35932,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 108,
			"byteOffset": 36220,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 36328,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 36712,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 256,
			"byteOffset": 37096,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 180,
			"byteOffset": 37352,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2004,
			"byteOffset": 37532,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2004,
			"byteOffset": 39536,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1336,
			"byteOffset": 41540,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 42876,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 43452,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 53628,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6784,
			"byteOffset": 63804,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 70588,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 71020,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 71452,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 71740,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 72172,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 72604,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 72892,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 73324,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 73756,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 74044,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 74476,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 74908,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 75196,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 75772,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 76348,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 76732,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 77116,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 256,
			"byteOffset": 77500,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 77756,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 87932,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6784,
			"byteOffset": 98108,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 104892,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 105324,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 105756,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 106044,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 106476,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 106908,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 107196,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 107628,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 108060,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 108348,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 108780,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 109212,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 109500,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 110076,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 110652,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 111036,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 111420,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 256,
			"byteOffset": 111804,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 112060,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 10176,
			"byteOffset": 122236,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6784,
			"byteOffset": 132412,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 139196,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 139628,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 140060,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 140348,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 140780,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 141212,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 141500,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 141932,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 142364,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 142652,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 432,
			"byteOffset": 143084,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 143516,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 143804,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 144380,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 144956,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 145340,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 145724,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 256,
			"byteOffset": 146108,
			"target": 34962
		}
	],
	"buffers": [
		{
			"byteLength": 146364,
			"uri": "mushroom%20cluster.bin"
		}
	]
}
